import React, { useState, useRef, useEffect, useContext } from "react";
import "../../style/main.scss";
import Navimg from "../../assets/images/sssvg nav.svg";
import Profile from "../../assets/images/profile.svg";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../app/context";
const Navbar = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const location = useLocation();
  const currentPath = location.pathname;
  const [isDropdownOpen, setDropdownOpen] = useState(true);
  const dropdownRef = useRef(null);

  const handleSVGClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const [isOtherDropdownOpen, setOtherDropdownOpen] = useState(true);
  const otherDropdownRef = useRef(null);

  const handleSVGClickOther = () => {
    setOtherDropdownOpen(!isOtherDropdownOpen);
    // console.log("click other");
  };

  const handleClickOutsideOther = (event) => {
    if (
      otherDropdownRef.current &&
      !otherDropdownRef.current.contains(event.target)
    ) {
      setOtherDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideOther);
    return () => {
      document.removeEventListener("click", handleClickOutsideOther);
    };
  }, []); // Cleanup the event listener on component unmount

  return (
    <div>
      <div className="playbook-Header">
        <nav className="navbar navbar-expand-lg mainnavbar">
          <div className="container-fluid maincontainer">
            {/* <a className="navbar-brand" href="#">
    
              <img src={Navlogo} alt="logo" />
            </a> */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <Icon
                icon="mdi:hamburger-menu"
                color="white"
                width="24"
                height="24"
              />
              {/* <span className="navbar-toggler-icon"></span> */}
            </button>
            <img src={Navimg} alt="background-img" className="profile-bg" />
            <div className="collapse navbar-collapse uldiv" id="navbarScroll">
              <ul
                className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll navul "
                //   style="--bs-scroll-height: 100px;"
              >
                {/* Dashboard */}
                {user.role === "coach" ||
                user.role === "member" ||
                user.role === "user" ||
                user.isAdmin === false ||
                user?.role !== "admin" ? (
                  <>
                    <li className="nav-item d-none">
                      <Link
                        style={{
                          color:
                            currentPath === "/dashboardland"
                              ? "#00A2D6"
                              : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        // href="#"
                        to={"/dashboardland"}
                        // onClick={() => handleSetActiveLink("dashboard")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="22"
                          viewBox="0 0 27 22"
                          fill="none"
                          className="firstsvg"
                        >
                          <g clip-path="url(#clip0_801_1290)">
                            <path
                              d="M5.7873 13.498C5.7873 12.9657 5.59899 12.5113 5.22237 12.1346C4.84575 11.758 4.3913 11.5697 3.85901 11.5697C3.32672 11.5697 2.87227 11.758 2.49565 12.1346C2.11904 12.5113 1.93073 12.9657 1.93073 13.498C1.93073 14.0303 2.11904 14.4847 2.49565 14.8613C2.87227 15.238 3.32672 15.4263 3.85901 15.4263C4.3913 15.4263 4.84575 15.238 5.22237 14.8613C5.59899 14.4847 5.7873 14.0303 5.7873 13.498ZM8.67972 6.749C8.67972 6.21671 8.49141 5.76226 8.11479 5.38564C7.73818 5.00902 7.28372 4.82071 6.75144 4.82071C6.21915 4.82071 5.7647 5.00902 5.38808 5.38564C5.01146 5.76226 4.82315 6.21671 4.82315 6.749C4.82315 7.28128 5.01146 7.73574 5.38808 8.11235C5.7647 8.48897 6.21915 8.67728 6.75144 8.67728C7.28372 8.67728 7.73818 8.48897 8.11479 8.11235C8.49141 7.73574 8.67972 7.28128 8.67972 6.749ZM15.1274 13.9951L16.649 8.2404C16.7092 7.97928 16.6716 7.73574 16.536 7.50976C16.4004 7.28379 16.2071 7.13566 15.956 7.06535C15.7049 6.99505 15.4639 7.02769 15.2329 7.16328C15.0019 7.29886 14.8512 7.49721 14.7809 7.75833L13.2594 13.5131C12.6568 13.5633 12.1195 13.7817 11.6475 14.1684C11.1754 14.555 10.8591 15.0497 10.6984 15.6522C10.4975 16.4256 10.598 17.1587 10.9997 17.8517C11.4014 18.5447 11.9889 18.9916 12.7623 19.1925C13.5356 19.3933 14.2687 19.2929 14.9617 18.8912C15.6547 18.4894 16.1016 17.9019 16.3025 17.1286C16.4632 16.526 16.433 15.9385 16.2121 15.366C15.9911 14.7936 15.6296 14.3366 15.1274 13.9951ZM25.0701 13.498C25.0701 12.9657 24.8818 12.5113 24.5052 12.1346C24.1286 11.758 23.6741 11.5697 23.1419 11.5697C22.6096 11.5697 22.1551 11.758 21.7785 12.1346C21.4019 12.5113 21.2136 12.9657 21.2136 13.498C21.2136 14.0303 21.4019 14.4847 21.7785 14.8613C22.1551 15.238 22.6096 15.4263 23.1419 15.4263C23.6741 15.4263 24.1286 15.238 24.5052 14.8613C24.8818 14.4847 25.0701 14.0303 25.0701 13.498ZM15.4287 3.85657C15.4287 3.32428 15.2404 2.86983 14.8638 2.49321C14.4872 2.11659 14.0327 1.92828 13.5004 1.92828C12.9681 1.92828 12.5137 2.11659 12.1371 2.49321C11.7605 2.86983 11.5721 3.32428 11.5721 3.85657C11.5721 4.38886 11.7605 4.84331 12.1371 5.21993C12.5137 5.59654 12.9681 5.78485 13.5004 5.78485C14.0327 5.78485 14.4872 5.59654 14.8638 5.21993C15.2404 4.84331 15.4287 4.38886 15.4287 3.85657ZM22.1777 6.749C22.1777 6.21671 21.9894 5.76226 21.6128 5.38564C21.2362 5.00902 20.7817 4.82071 20.2494 4.82071C19.7171 4.82071 19.2627 5.00902 18.8861 5.38564C18.5095 5.76226 18.3211 6.21671 18.3211 6.749C18.3211 7.28128 18.5095 7.73574 18.8861 8.11235C19.2627 8.48897 19.7171 8.67728 20.2494 8.67728C20.7817 8.67728 21.2362 8.48897 21.6128 8.11235C21.9894 7.73574 22.1777 7.28128 22.1777 6.749ZM26.9984 13.498C26.9984 16.1193 26.2904 18.5447 24.8743 20.7743C24.6835 21.0655 24.4123 21.2111 24.0608 21.2111H2.94006C2.58855 21.2111 2.31739 21.0655 2.12657 20.7743C0.710483 18.5547 0.00244141 16.1293 0.00244141 13.498C0.00244141 11.6701 0.358973 9.92263 1.07204 8.25547C1.7851 6.58831 2.74422 5.15214 3.9494 3.94696C5.15458 2.74178 6.59075 1.78266 8.25791 1.0696C9.92507 0.356532 11.6726 0 13.5004 0C15.3283 0 17.0758 0.356532 18.743 1.0696C20.4101 1.78266 21.8463 2.74178 23.0515 3.94696C24.2566 5.15214 25.2158 6.58831 25.9288 8.25547C26.6419 9.92263 26.9984 11.6701 26.9984 13.498Z"
                              fill="white"
                              style={{
                                fill:
                                  currentPath === "/dashboardland"
                                    ? "#00A2D6"
                                    : "white",
                              }}
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_801_1290">
                              <rect width="27" height="21.2111" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Dashboard
                      </Link>
                    </li>
                    {/* New Strategic Plan */}
                    <li className="nav-item">
                      <Link
                        style={{
                          color: currentPath === "/plan" ? "#00A2D6" : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/plan"}
                        // onClick={() => handleSetActiveLink("2")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="24"
                          viewBox="0 0 27 24"
                          fill="none"
                          className="firstsvg"
                        >
                          <path
                            d="M11.3314 13.5749H4.51074V10.4249H11.3314V4.1499H14.7553V10.4249H21.576V13.5749H14.7553V19.8499H11.3314V13.5749Z"
                            fill="white"
                            style={{
                              fill:
                                currentPath === "/plan" ? "#00A2D6" : "white",
                            }}
                          />
                        </svg>
                        New Strategic Plan
                      </Link>
                    </li>
                    {/* Strategic Plans */}
                    <li className="nav-item">
                      <Link
                        style={{
                          color: currentPath === "/plans" ? "#00A2D6" : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/plans"}
                        // onClick={() => handleSetActiveLink("strategyplan")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          className="firstsvg"
                        >
                          <g clip-path="url(#clip0_801_33)">
                            <path
                              d="M11.6848 0.564719C11.7844 0.521535 11.8916 0.499268 12 0.499268C12.1084 0.499268 12.2156 0.521535 12.3152 0.564719L23.2 5.28366L12 10.1385L0.8 5.28366L11.6848 0.564719ZM0 6.69805V19.1104C0 19.434 0.192 19.7253 0.4848 19.8548L11.2 24.4993V11.5529L0 6.69805ZM12.8 11.5529L24 6.69805V19.1104C24.0001 19.2688 23.9543 19.4238 23.8681 19.5562C23.7819 19.6885 23.6592 19.7923 23.5152 19.8548L12.8 24.4993V11.5529Z"
                              fill="white"
                              style={{
                                fill:
                                  currentPath === "/plans"
                                    ? "#00A2D6"
                                    : "white",
                              }}
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_801_33">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                style={{
                                  fill:
                                    currentPath === "/goal"
                                      ? "#00A2D6"
                                      : "white",
                                }}
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        Strategic Plans
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{
                          color:
                            currentPath === "/meetingagenda"
                              ? "#00A2D6"
                              : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/meetingagenda"}
                        target="_blank"
                        // onClick={() => handleSetActiveLink("plan")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          className="firstsvg"
                        >
                          <path
                            d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                            fill="white"
                            style={{
                              fill:
                                currentPath === "/meetingagenda"
                                  ? "#00A2D6"
                                  : "white",
                            }}
                          />
                        </svg>
                        Meeting Agenda
                      </Link>
                    </li>
                  </>
                ) : (
                  <></>
                )}

                {/* <li className="nav-item">
                  <Link
                    style={{
                      color:
                        currentPath === "/subscriptions" ? "#00A2D6" : "white",
                    }}
                    className="nav-link"
                    aria-current="page"
                    to={"/subscriptions"}
                    // onClick={() => handleSetActiveLink("plan")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      className="firstsvg"
                    >
                      <path
                        d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                        fill="white"
                        style={{
                          fill:
                            currentPath === "/subscriptions"
                              ? "#00A2D6"
                              : "white",
                        }}
                      />
                    </svg>
                    My Plan
                  </Link>
                </li> */}
                {(user?.isAdmin === true || user?.role === "admin") && (
                  <>
                    <li className="nav-item">
                      <Link
                        style={{
                          color:
                            currentPath === "/admindashboard"
                              ? "#00A2D6"
                              : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/admindashboard"}
                        // onClick={() => handleSetActiveLink("plan")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="24"
                          viewBox="0 0 27 24"
                          fill="none"
                          className="firstsvg"
                        >
                          <path
                            d="M11.3314 13.5749H4.51074V10.4249H11.3314V4.1499H14.7553V10.4249H21.576V13.5749H14.7553V19.8499H11.3314V13.5749Z"
                            fill="white"
                            style={{
                              fill:
                                currentPath === "/admindashboard"
                                  ? "#00A2D6"
                                  : "white",
                            }}
                          />
                        </svg>
                        Add coach
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{
                          color:
                            currentPath === "/coachestable"
                              ? "#00A2D6"
                              : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/coachestable"}
                        // onClick={() => handleSetActiveLink("plan")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          className="firstsvg"
                        >
                          <path
                            d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                            fill="white"
                            style={{
                              fill:
                                currentPath === "/coachestable"
                                  ? "#00A2D6"
                                  : "white",
                            }}
                          />
                        </svg>
                        Coaches List
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{
                          color:
                            currentPath === "/dashboard/admin"
                              ? "#00A2D6"
                              : "white",
                        }}
                        className="nav-link"
                        aria-current="page"
                        to={"/dashboard/admin"}

                        // onClick={() => handleSetActiveLink("plan")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          className="firstsvg"
                        >
                          <path
                            d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                            fill="white"
                            style={{
                              fill:
                                currentPath === "/dashboard/admin"
                                  ? "#00A2D6"
                                  : "white",
                            }}
                          />
                        </svg>
                        Dashboard
                      </Link>
                    </li>
                    {!currentPath?.includes("/dashboard/admin") && (
                      <li className="nav-item">
                        <Link
                          style={{
                            color:
                              currentPath === "/meetingagenda"
                                ? "#00A2D6"
                                : "white",
                          }}
                          className="nav-link"
                          aria-current="page"
                          to={"/meetingagenda"}
                          target="_blank"
                          // onClick={() => handleSetActiveLink("plan")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            className="firstsvg"
                          >
                            <path
                              d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                              fill="white"
                              style={{
                                fill:
                                  currentPath === "/meetingagenda"
                                    ? "#00A2D6"
                                    : "white",
                              }}
                            />
                          </svg>
                          Meeting Agenda
                        </Link>
                      </li>
                    )}
                  </>
                )}
                {/* <li className="nav-item">
                  <Link
                    style={{
                      color:
                        currentPath === "/meetingoctaloop"
                          ? "#00A2D6"
                          : "white",
                    }}
                    className="nav-link"
                    aria-current="page"
                    to={"/meetingoctaloop"}
                    // onClick={() => handleSetActiveLink("plan")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      className="firstsvg"
                    >
                      <path
                        d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                        fill="white"
                        style={{
                          fill:
                            currentPath === "/meetingoctaloop"
                              ? "#00A2D6"
                              : "white",
                        }}
                      />
                    </svg>
                    Meeting
                  </Link>
                </li> */}
              </ul>
              <form className="navbarLast" role="search">
                {/* <button className="btn btn-outline-success" type="submit">
                  Search
                </button> */}
                {/* <img src={Rightbg} alt="" className="imgline" /> */}
                <div className="dropdown-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    className="firstsvg"
                    onClick={handleSVGClick}
                  >
                    <path
                      d="M46 42.4444V44H18V42.4444L21.1111 39.3333V30C21.1111 25.1778 24.2689 20.9311 28.8889 19.5622V19.1111C28.8889 18.286 29.2167 17.4947 29.8001 16.9112C30.3836 16.3278 31.1749 16 32 16C32.8251 16 33.6164 16.3278 34.1999 16.9112C34.7833 17.4947 35.1111 18.286 35.1111 19.1111V19.5622C39.7311 20.9311 42.8889 25.1778 42.8889 30V39.3333L46 42.4444ZM35.1111 45.5556C35.1111 46.3807 34.7833 47.172 34.1999 47.7554C33.6164 48.3389 32.8251 48.6667 32 48.6667C31.1749 48.6667 30.3836 48.3389 29.8001 47.7554C29.2167 47.172 28.8889 46.3807 28.8889 45.5556"
                      fill="white"
                    />
                    <circle cx="36.5" cy="19.5" r="4.5" fill="#E9F1FF" />
                  </svg>

                  {!isDropdownOpen && (
                    <>
                      <div className="bottomdiv" ref={dropdownRef}>
                        <div className="Notification">
                          <span>Notifications</span>
                        </div>
                        <div className="noNotification">
                          <span>No Notifications</span>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          setDropdownOpen(true);
                        }}
                        className="closediv"
                      >
                        {" "}
                        ideas{" "}
                      </div>
                    </>
                  )}
                </div>
                {/*  second svg/ */}
                <div className="dropdown-containerss">
                  <img
                    width={40}
                    height={40}
                    style={{ borderRadius: "50%" }}
                    className=""
                    src={user?.picture || Profile}
                    alt=""
                    onClick={handleSVGClickOther}
                  />
                  {!isOtherDropdownOpen && (
                    <>
                      {" "}
                      <div className="bottomdiv" ref={otherDropdownRef}>
                        <div
                          className="noNotification"
                          onClick={() => {
                            // e.preventDefault();
                            navigate("/profile");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M5.33333 4.66667C5.33333 3.95942 5.61428 3.28115 6.11438 2.78105C6.61448 2.28095 7.29276 2 8 2C8.70724 2 9.38552 2.28095 9.88562 2.78105C10.3857 3.28115 10.6667 3.95942 10.6667 4.66667C10.6667 5.37391 10.3857 6.05219 9.88562 6.55229C9.38552 7.05238 8.70724 7.33333 8 7.33333C7.29276 7.33333 6.61448 7.05238 6.11438 6.55229C5.61428 6.05219 5.33333 5.37391 5.33333 4.66667ZM5.33333 8.66667C4.44928 8.66667 3.60143 9.01786 2.97631 9.64298C2.35119 10.2681 2 11.1159 2 12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14H12C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.1159 13.6488 10.2681 13.0237 9.64298C12.3986 9.01786 11.5507 8.66667 10.6667 8.66667H5.33333Z"
                              fill="#0D4D80"
                            />
                          </svg>
                          <span> My Profile</span>
                        </div>
                        {/* <div
                          className="noNotification"
                          onClick={() => {
                            navigate("/addteam");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M8 2.50201C7.73762 2.50201 7.47781 2.55369 7.2354 2.6541C6.99299 2.75451 6.77273 2.90168 6.5872 3.08721C6.40167 3.27275 6.2545 3.493 6.15409 3.73541C6.05368 3.97782 6.002 4.23763 6.002 4.50001C6.002 4.7624 6.05368 5.02221 6.15409 5.26462C6.2545 5.50702 6.40167 5.72728 6.5872 5.91281C6.77273 6.09834 6.99299 6.24552 7.2354 6.34593C7.47781 6.44633 7.73762 6.49801 8 6.49801C8.5299 6.49801 9.0381 6.28751 9.4128 5.91281C9.7875 5.53812 9.998 5.02992 9.998 4.50001C9.998 3.97011 9.7875 3.46191 9.4128 3.08721C9.0381 2.71252 8.5299 2.50201 8 2.50201ZM12.5 3.50001C12.1022 3.50001 11.7206 3.65805 11.4393 3.93935C11.158 4.22066 11 4.60219 11 5.00001C11 5.39784 11.158 5.77937 11.4393 6.06067C11.7206 6.34198 12.1022 6.50001 12.5 6.50001C12.8978 6.50001 13.2794 6.34198 13.5607 6.06067C13.842 5.77937 14 5.39784 14 5.00001C14 4.60219 13.842 4.22066 13.5607 3.93935C13.2794 3.65805 12.8978 3.50001 12.5 3.50001ZM3.5 3.50001C3.10218 3.50001 2.72064 3.65805 2.43934 3.93935C2.15804 4.22066 2 4.60219 2 5.00001C2 5.39784 2.15804 5.77937 2.43934 6.06067C2.72064 6.34198 3.10218 6.50001 3.5 6.50001C3.89783 6.50001 4.27936 6.34198 4.56066 6.06067C4.84197 5.77937 5 5.39784 5 5.00001C5 4.60219 4.84197 4.22066 4.56066 3.93935C4.27936 3.65805 3.89783 3.50001 3.5 3.50001ZM5 8.49301C5.00185 8.22901 5.10802 7.97645 5.29536 7.79043C5.48269 7.6044 5.73599 7.50001 6 7.50001H10C10.2652 7.50001 10.5196 7.60537 10.7071 7.79291C10.8946 7.98044 11 8.2348 11 8.50001V11.5C10.9999 11.8147 10.9507 12.1275 10.854 12.427C10.6326 13.1057 10.1764 13.6833 9.56751 14.0559C8.95859 14.4286 8.23675 14.5719 7.53163 14.4603C6.8265 14.3486 6.18428 13.9893 5.72028 13.4467C5.25628 12.9041 5.0009 12.2139 5 11.5V8.49301ZM4 8.50001C4 8.13501 4.097 7.79401 4.268 7.50001H2C1.73478 7.50001 1.48043 7.60537 1.29289 7.79291C1.10536 7.98044 1 8.2348 1 8.50001V11C0.999864 11.4093 1.10023 11.8124 1.29227 12.1739C1.48432 12.5353 1.76218 12.8441 2.10144 13.0731C2.44071 13.302 2.831 13.4442 3.23806 13.4871C3.64511 13.53 4.05646 13.4723 4.436 13.319C4.14818 12.7556 3.99872 12.1317 4 11.499V8.50001ZM12 8.50001V11.5C12 12.155 11.843 12.773 11.564 13.319C11.9435 13.4723 12.3549 13.53 12.7619 13.4871C13.169 13.4442 13.5593 13.302 13.8986 13.0731C14.2378 12.8441 14.5157 12.5353 14.7077 12.1739C14.8998 11.8124 15.0001 11.4093 15 11V8.50001C15 8.2348 14.8946 7.98044 14.7071 7.79291C14.5196 7.60537 14.2652 7.50001 14 7.50001H11.732C11.902 7.79401 12 8.13501 12 8.50001Z"
                              fill="#0D4D80"
                            />
                          </svg>
                          <span> Team Members</span>
                        </div> */}
                        <div
                          className="noNotification"
                          onClick={() => {
                            navigate("/subscriptions");
                          }}
                        >
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M8 2.50201C7.73762 2.50201 7.47781 2.55369 7.2354 2.6541C6.99299 2.75451 6.77273 2.90168 6.5872 3.08721C6.40167 3.27275 6.2545 3.493 6.15409 3.73541C6.05368 3.97782 6.002 4.23763 6.002 4.50001C6.002 4.7624 6.05368 5.02221 6.15409 5.26462C6.2545 5.50702 6.40167 5.72728 6.5872 5.91281C6.77273 6.09834 6.99299 6.24552 7.2354 6.34593C7.47781 6.44633 7.73762 6.49801 8 6.49801C8.5299 6.49801 9.0381 6.28751 9.4128 5.91281C9.7875 5.53812 9.998 5.02992 9.998 4.50001C9.998 3.97011 9.7875 3.46191 9.4128 3.08721C9.0381 2.71252 8.5299 2.50201 8 2.50201ZM12.5 3.50001C12.1022 3.50001 11.7206 3.65805 11.4393 3.93935C11.158 4.22066 11 4.60219 11 5.00001C11 5.39784 11.158 5.77937 11.4393 6.06067C11.7206 6.34198 12.1022 6.50001 12.5 6.50001C12.8978 6.50001 13.2794 6.34198 13.5607 6.06067C13.842 5.77937 14 5.39784 14 5.00001C14 4.60219 13.842 4.22066 13.5607 3.93935C13.2794 3.65805 12.8978 3.50001 12.5 3.50001ZM3.5 3.50001C3.10218 3.50001 2.72064 3.65805 2.43934 3.93935C2.15804 4.22066 2 4.60219 2 5.00001C2 5.39784 2.15804 5.77937 2.43934 6.06067C2.72064 6.34198 3.10218 6.50001 3.5 6.50001C3.89783 6.50001 4.27936 6.34198 4.56066 6.06067C4.84197 5.77937 5 5.39784 5 5.00001C5 4.60219 4.84197 4.22066 4.56066 3.93935C4.27936 3.65805 3.89783 3.50001 3.5 3.50001ZM5 8.49301C5.00185 8.22901 5.10802 7.97645 5.29536 7.79043C5.48269 7.6044 5.73599 7.50001 6 7.50001H10C10.2652 7.50001 10.5196 7.60537 10.7071 7.79291C10.8946 7.98044 11 8.2348 11 8.50001V11.5C10.9999 11.8147 10.9507 12.1275 10.854 12.427C10.6326 13.1057 10.1764 13.6833 9.56751 14.0559C8.95859 14.4286 8.23675 14.5719 7.53163 14.4603C6.8265 14.3486 6.18428 13.9893 5.72028 13.4467C5.25628 12.9041 5.0009 12.2139 5 11.5V8.49301ZM4 8.50001C4 8.13501 4.097 7.79401 4.268 7.50001H2C1.73478 7.50001 1.48043 7.60537 1.29289 7.79291C1.10536 7.98044 1 8.2348 1 8.50001V11C0.999864 11.4093 1.10023 11.8124 1.29227 12.1739C1.48432 12.5353 1.76218 12.8441 2.10144 13.0731C2.44071 13.302 2.831 13.4442 3.23806 13.4871C3.64511 13.53 4.05646 13.4723 4.436 13.319C4.14818 12.7556 3.99872 12.1317 4 11.499V8.50001ZM12 8.50001V11.5C12 12.155 11.843 12.773 11.564 13.319C11.9435 13.4723 12.3549 13.53 12.7619 13.4871C13.169 13.4442 13.5593 13.302 13.8986 13.0731C14.2378 12.8441 14.5157 12.5353 14.7077 12.1739C14.8998 11.8124 15.0001 11.4093 15 11V8.50001C15 8.2348 14.8946 7.98044 14.7071 7.79291C14.5196 7.60537 14.2652 7.50001 14 7.50001H11.732C11.902 7.79401 12 8.13501 12 8.50001Z"
                              fill="#0D4D80"
                            />
                          </svg> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 24 25"
                            fill="none"
                            className="firstsvg"
                          >
                            <path
                              d="M22.125 8.51181C21.9846 8.35147 21.8116 8.22288 21.6176 8.13462C21.4237 8.04635 21.2131 8.00044 21 7.99994H17.5903L12.5625 2.25587C12.4921 2.17607 12.4055 2.11215 12.3086 2.06837C12.2116 2.02459 12.1064 2.00195 12 2.00195C11.8936 2.00195 11.7884 2.02459 11.6914 2.06837C11.5944 2.11215 11.5079 2.17607 11.4375 2.25587L6.40966 7.99994H2.99998C2.78629 7.99994 2.57507 8.0456 2.38046 8.13386C2.18585 8.22212 2.01234 8.35094 1.87156 8.51169C1.73078 8.67245 1.62596 8.86143 1.56414 9.06598C1.50232 9.27053 1.48492 9.48593 1.5131 9.69775L2.81248 19.4487C2.86065 19.8091 3.03807 20.1397 3.31175 20.379C3.58542 20.6184 3.93671 20.7502 4.30029 20.7499H19.6997C20.0632 20.7502 20.4145 20.6184 20.6882 20.379C20.9619 20.1397 21.1393 19.8091 21.1875 19.4487L22.4878 9.69869C22.5155 9.48642 22.4975 9.27068 22.4349 9.06597C22.3723 8.86125 22.2666 8.6723 22.125 8.51181ZM7.64998 17.7499C7.62468 17.7513 7.59933 17.7513 7.57404 17.7499C7.38746 17.7509 7.20724 17.6822 7.06856 17.5574C6.92987 17.4326 6.84269 17.2606 6.82404 17.0749L6.29904 11.8249C6.27915 11.627 6.33869 11.4293 6.46458 11.2753C6.59046 11.1213 6.77237 11.0236 6.97029 11.0037C7.16821 10.9838 7.36592 11.0433 7.51993 11.1692C7.67395 11.2951 7.77165 11.477 7.79154 11.6749L8.31654 16.9249C8.33754 17.1227 8.27912 17.3208 8.15411 17.4755C8.02911 17.6302 7.84777 17.7289 7.64998 17.7499ZM12.75 16.9999C12.75 17.1988 12.671 17.3896 12.5303 17.5303C12.3897 17.6709 12.1989 17.7499 12 17.7499C11.8011 17.7499 11.6103 17.6709 11.4696 17.5303C11.329 17.3896 11.25 17.1988 11.25 16.9999V11.7499C11.25 11.551 11.329 11.3603 11.4696 11.2196C11.6103 11.079 11.8011 10.9999 12 10.9999C12.1989 10.9999 12.3897 11.079 12.5303 11.2196C12.671 11.3603 12.75 11.551 12.75 11.7499V16.9999ZM8.40279 7.99994L12 3.889L15.5972 7.99994H8.40279ZM17.6962 11.8249L17.1712 17.0749C17.1527 17.2598 17.0661 17.4311 16.9284 17.5558C16.7908 17.6805 16.6117 17.7497 16.4259 17.7499C16.4006 17.7513 16.3753 17.7513 16.35 17.7499C16.252 17.7401 16.1569 17.711 16.0701 17.6644C15.9833 17.6178 15.9066 17.5546 15.8443 17.4783C15.7819 17.4021 15.7352 17.3143 15.7068 17.22C15.6784 17.1257 15.6689 17.0267 15.6787 16.9287L16.2037 11.6787C16.2236 11.4808 16.3213 11.2989 16.4753 11.173C16.6293 11.0471 16.8271 10.9875 17.025 11.0074C17.2229 11.0273 17.4048 11.125 17.5307 11.279C17.6566 11.4331 17.7161 11.6308 17.6962 11.8287V11.8249Z"
                              fill="white"
                              style={{
                                fill:
                                  currentPath === "/subscriptions"
                                    ? "#0D4D80"
                                    : "#0D4D80",
                              }}
                            />
                          </svg>

                          <span> My Plan</span>
                        </div>
                        <div
                          className="noNotification"
                          onClick={() => {
                            localStorage.removeItem("plan");
                            localStorage.removeItem("User");
                            localStorage.removeItem("role");
                            navigate("/");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M11.333 5.16667L10.393 6.10667L12.113 7.83333H5.33301V9.16667H12.113L10.393 10.8867L11.333 11.8333L14.6663 8.5L11.333 5.16667ZM2.66634 3.83333H7.99967V2.5H2.66634C1.93301 2.5 1.33301 3.1 1.33301 3.83333V13.1667C1.33301 13.9 1.93301 14.5 2.66634 14.5H7.99967V13.1667H2.66634V3.83333Z"
                              fill="#0D4D80"
                            />
                          </svg>
                          <span> Logout</span>

                          {/* <span ><p onClick={   navigate("/")} >Logout</p></span> */}
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          setOtherDropdownOpen(true);
                        }}
                        className="closediv"
                      >
                        {" "}
                        ideas{" "}
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
